import FullLayout from '../../pages/dashboard/FullLayout';
import LoginPage from '../../pages/login/Login';

var indexRoutes = [
    { path: "/login", name: "Login", component: LoginPage },
    { path: '/', name: 'DashBoard', component: FullLayout }
];

export default indexRoutes;